module.exports = __webpack_public_path__ + "assets/img/1021587020667_.pic_hd.79160456.jpg";